import { applyMiddleware, compose, createStore as createReduxStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { connectedRouterMiddleware } from './router';
import makeRootReducer from './reducers';
import rootSaga from '../sagas';

const composeEnhancers =
  window.__DEV__ && typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function'
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const sagaMiddleware = createSagaMiddleware();

const createStore = (initialState = {}) => {
  const middleware = [sagaMiddleware, connectedRouterMiddleware];

  const enhancers = composeEnhancers(applyMiddleware(...middleware));
  const store = createReduxStore(makeRootReducer(), initialState, enhancers);
  store.asyncReducers = {};

  // Run saga
  sagaMiddleware.run(rootSaga);

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  return store;
};

export default createStore;



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/store/createStore.js